module.exports = __webpack_public_path__ + "img/just_logo_light2.defb358d.png";